import { useMutation } from '@tanstack/react-query';
import { IProduct } from 'src/interfaces';
import { requestCCApi } from 'src/utils';

export const useCreateProductCategory = () => {
  return useMutation({
    mutationFn: createProductCategory,
  });
};

const createProductCategory = async (payload: Partial<IProduct>) => {
  const request = {
    name: payload.product_name,
  };

  const response = await requestCCApi({
    url: `/productCategories`,
    method: 'POST',
    data: { data: request },
  });

  return response;
};
